import { configureStore } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';
import rootReducer from '../Common/Reducer/rootReducer';

// ----------------------------------------------------------------------

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(logger)
})

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

const { dispatch } = store;

const useSelector = useReduxSelector;
const useDispatch = () => useReduxDispatch<AppDispatch>();

export { store, dispatch, useSelector, useDispatch };
